import { useEffect } from "react";

/**
 * Injects a JSON-LD structured data script into <head> for the current page.
 * Cleans up on unmount to keep the DOM tidy on SPA navigation.
 */
export const useJsonLd = (schema, id) => {
  useEffect(() => {
    if (!schema) return;
    const scriptId = id || `jsonld-${Math.random().toString(36).slice(2, 10)}`;

    // Remove any existing script with same id
    const existing = document.getElementById(scriptId);
    if (existing) existing.remove();

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = scriptId;
    try {
      script.text = JSON.stringify(schema);
    } catch (e) {
      return;
    }
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById(scriptId);
      if (el) el.remove();
    };
  }, [schema, id]);
};
